module.exports = {
  "version": "0.27.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 238
// module chunks = 0